<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70" style="padding: 0px;">
  <div class="col-md-6 mt-6 mx-auto">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td class="v-align-m">Product ID</td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedproductId"
              placeholder=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Contract Id</th>
          <th scope="col">Contracted Date</th>
          <th scope="col">Author Name</th>
          <th scope="col">Netsuite Id</th>
          <th scope="col">Product Id</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">Royalty Type</th>
          <th scope="col">Book Type</th>
          <th scope="col">Band 1 (%)</th>
          <th scope="col">Band 2 (%)</th>
          <th scope="col">Band 3 (%)</th>
          <th scope="col">Status</th>
          <th scope="col">Contract Type</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of products">
          <ng-container *ngFor="let royaltyType of royaltyTypes">
            <tr>
              <td>
                {{ (product?.contract && product.contract.length > 0) ?
                product.contract[0]?.id : '' }}
              </td>
              <td>
                {{ (product?.product && product.product.length > 0) ?
                product?.product[0]?.date?.contracted_date : ''}}
              </td>
              <td>
                {{ (product?.contract && product.contract.length > 0) ?
                product.contract[0]?.author?.name : '' }}
              </td>
              <td>
                {{ (product?.contract && product.contract.length > 0) ?
                product?.contract[0]?.author?.contact[0]?.netsuite_internal_id :
                '' }}
              </td>
              <td>
                {{ (product?.product && product.product.length > 0) ?
                product?.product[0]?.part_number : ''}}
              </td>
              <td>
                {{ (product?.product && product.product.length > 0) ?
                product?.product[0]?.isbn?.isbn_10 : ''}}
              </td>
              <td>{{ getRoyaltyValue(royaltyType) }}</td>
              <td>
                {{ (product?.product && product.product.length > 0) ?
                product?.product[0]?.type[0]?.format : '' }}
              </td>
              <td *ngFor="let band of bands">
                {{ getRoyaltyBandData(product, royaltyType)[bands.indexOf(band)]
                }}
              </td>
              <td>
                {{ (product?.contract && product.contract.length > 0) ?
                product?.contract[0]?.status: '' }}
              </td>
              <td>
                {{ (product?.contract && product.contract.length > 0) ?
                product?.contract[0]?.royalty_type : '' }}
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <!-- <tr *ngFor="let product of products; let i = index;">
          <td>{{ product.contract_id }}</td>
          <td>{{ product.contracted_date }}</td>
          <td>{{ product.author_name }}</td>
          <td>{{ product.contact_netsuite_id }}</td>
          <td>{{ product.part_number }}</td>
          <td>{{ product.isbn_10p }}</td>
          <td>{{ product.type }}</td>
          <td>{{ product.book_type }}</td>
          <td>{{ product?.bands[0] }}</td>
          <td>{{ product?.bands[1] }}</td>
          <td>{{ product?.bands[2] }}</td>
          <td>{{ product.contract_status }}</td>
          <td>{{ product.contract_type }}</td>

        </tr> -->
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="10"
    [pageSize]="3"
    [collectionSize]="totalProducts * 9"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>
<app-footer></app-footer>
